import React, { useEffect, useState } from "react";
import { supabase } from "./Main";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/navigation';
import '../propiedadesStyles.css'

const Propiedades = () => {
  const [propiedades, setPropiedades] = useState([]);

  useEffect(() => {
    (async () => {
      const { data, error } = await supabase
        .from("propiedades")
        .select(`*, imagenes ( imagen_url )`);
      if (!error) setPropiedades(data);
    })();
  }, []);

  return (
    <section className="section text-center">
      <h2>Todas las Propiedades</h2>
      <p>Estas son todas las propiedades disponibles.</p>
      <div className="propiedades-grid">
        {propiedades.map(propiedad => (
          <div className="propiedad-card" key={propiedad.id}>
            <div className="propiedad-imagenes">
              <Swiper navigation={true} modules={[Navigation]}>
                {propiedad.imagenes.length === 0 ? (
                  <SwiperSlide>
                    <img
                      src="https://t3.ftcdn.net/jpg/02/68/55/60/360_F_268556012_c1WBaKFN5rjRxR2eyV33znK4qnYeKZjm.jpg"
                      alt="Sin imágenes"
                    />
                  </SwiperSlide>
                ) : (
                  propiedad.imagenes.map((img, idx) => (
                    <SwiperSlide key={idx}>
                      <img src={img.imagen_url} alt={`Imagen ${idx + 1}`} />
                    </SwiperSlide>
                  ))
                )}
              </Swiper>
            </div>
            <div className="propiedad-info">
              <h3>{propiedad.titulo}</h3>
              <p>{propiedad.direccion}</p>
              <p>{propiedad.descripcion}</p>
              <a href={`/propiedad/${propiedad.id}`} className="btn">Ver Propiedad</a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Propiedades;